<div class="overlay-related-container overlay-related"
    [ngClass]="{'overlay-active': loadOverlay, 'overlay-remove': !showOverlay}">
    <img  class="overlay-related-wrapper" src="{{relatedOverlay?.image}}" alt="">
    <div class="single-item-content-wrapper">
        <div class="d-md-block absoulte-middle space-1 index-extralarge">
            <h3 class="heading3 animate-content text-uppercase" 
            [ngClass]="{'animate-content-active':videocontentActive,
                        'f-white':relatedOverlay?.colors == 'white',
                        'f-darker':relatedOverlay?.colors == 'black'}">{{relatedOverlay?.subtitle}}</h3>

            <h1 class="heading1 font-bold animate-content" 
            [ngClass]="{'animate-content-active':videotitleActive,
                        'f-white':relatedOverlay?.colors == 'white',
                        'f-darker':relatedOverlay?.colors == 'black'}">{{relatedOverlay?.title}}</h1>
        </div> 
    </div> 
</div>

<div class="overlay-related-container overlay-quick-view-related"
    [ngClass]="{'overlay-active': loadOverlayQuick, 'overlay-remove': !showOverlayQuick}">
    <img  class="overlay-related-wrapper" src="{{relatedOverlayQuick?.image}}" alt="">
    <div class="single-item-content-wrapper">
        <div class="d-md-block absoulte-middle space-1 index-extralarge">
                        
            <h3 class="heading3 separate-top-8 animate-content" 
            [ngClass]="{'animate-content-active':videocontentActive,
                        'f-white':relatedOverlayQuick?.colors == 'white',
                        'f-darker':relatedOverlayQuick?.colors == 'black'}">{{relatedOverlayQuick?.subtitle}}</h3>

            <h1 class="heading1 animate-content"
            [ngClass]="{'animate-content-active':videotitleActive,
                        'f-white':relatedOverlayQuick?.colors == 'white',
                        'f-darker':relatedOverlayQuick?.colors == 'black'}">{{relatedOverlayQuick?.title}}</h1>
        </div> 
    </div> 
</div>